/** Endpoint #25 — Posts mode table page (§5.3, §5.4). */
import { z } from 'zod';
import { POSTS_SORT_KEYS } from '../columns.js';
import { SORT_DIRS, } from '../enums.js';
import { MAX_POSTS_LIMIT, ViewFilterParamsSchema } from './common.js';
/** #25 `GET /api/views/:t/:id/posts` */
export const PostsQuerySchema = ViewFilterParamsSchema.extend({
    sort: z.enum(POSTS_SORT_KEYS).default('publishedAt'),
    dir: z.enum(SORT_DIRS).default('desc'),
    offset: z.coerce.number().int().nonnegative().default(0),
    limit: z.coerce.number().int().positive().max(MAX_POSTS_LIMIT).default(MAX_POSTS_LIMIT),
});
//# sourceMappingURL=posts.js.map